// Copyright (c) 2016 Deere & Company

export default [
    {
        displayName: 'DAYS_LEFT',
        path: ['daysLeft']
    },
    {
        displayName: 'REQUESTED',
        path: ['requestDate']
    },
    {
        displayName: 'PART_REQUEST',
        path: ['rgaNumber']
    },
    {
        displayName: 'WORK_ORDER',
        path: ['reference1']
    },
    {
        displayName: 'CLAIM',
        path: ['claimNumber']
    },
    {
        displayName: 'PART_NUMBER',
        path: ['partNumber']
    },
    {
        displayName: 'PIN',
        path: ['pin']
    },
    {
        displayName: 'PRIORITY',
        path: ['isShipmentPriorityHigh', 'daysLeft']
    },
    {
        displayName: 'REQUEST_TYPE',
        path: ['requestType', 'value']
    }
];



// WEBPACK FOOTER //
// ./src/part-requests/shared/state/part-return-sort-options.js